import { FC } from "react";

/**
 * Props for the RegulationRevisionDates component.
 */
type PolicyDatesProps = {
  /**
   * The regulation date.
   */
  regulationDate: string;
  /**
   * The revision date (optional).
   */
  revisionDate?: string;
};

/**
 * Displays the regulation and revision dates.
 * @param regulationDate - The regulation date.
 * @param revisionDate - The revision date (optional).
 * @returns JSX element displaying the dates.
 */
export const RegulationRevisionDates: FC<PolicyDatesProps> = ({
  regulationDate,
  revisionDate,
}) => {
  const showRevisionDate = revisionDate && revisionDate.trim() !== "";
  return (
    <>
      制定：{regulationDate}
      {showRevisionDate && (
        <>
          <br />
          最終改定：{revisionDate}
        </>
      )}
    </>
  );
};

export default RegulationRevisionDates;
